angular.module('bmsApp.trugreen.quote').factory('TGJobSvc', function ($q,
																	  $modal,
																	  CRUDSvc,
																	  $rootScope,
																	  TGTreatmentSvc,
																	  TG_JOB_API,
																	  notify) {

	var self = {
		index: function (params) {
			return CRUDSvc.get(TG_JOB_API.INDEX, params);
		},
		quoteIndex: function (params) {
			return CRUDSvc.get(TG_JOB_API.QUOTE_INDEX, params);
		},
		save: function (job) {
			return CRUDSvc.post(TG_JOB_API.SAVE, job);
		},
		read: function (id, params) {
			return CRUDSvc.get(TG_JOB_API.READ + id, params);
		},
		convertToQuote: function(params) {
			return CRUDSvc.post(TG_JOB_API.CONVERT_TO_QUOTE, params);
		},
		quotesByCustomer: function (customerId, params) {
			var newParams = angular.extend({}, params, {
				filter: {
					converted: false,
					customer: customerId
				}
			});
			return CRUDSvc.get(TG_JOB_API.INDEX, newParams);
		},
		showCopyQuoteModal: function(job) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/trugreen/job/templates/modals/TGCopyJobModal.html',
				controller: 'TGCopyJobModalCtrl',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					job: function () {
						return angular.copy(job);
					}
				}
			});

			return modalInstance.result;
		},

		showTreatmentPlanEmailFormModal: function(email, job) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/trugreen/job/templates/modals/TreatmentPlanEmailFormModal.html',
				controller: 'TreatmentPlanEmailFormModalCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					job: function () {
						return angular.copy(job);
					},
					customer: function () {
						return angular.copy(job.customer);
					},
					email: function () {
						return angular.copy(email);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					notify({
						message: 'Treatment plan email sent successfully'
					});
				}
				else {
					notify({
						message: result.error,
						classes: 'error',
						duration: '0'
					});
				}
			}, function () {
				// closed
			});

		},

		getTreatmentPlanEmailTemplate: function(jobId) {
			return CRUDSvc.get(TG_JOB_API.TP_EMAIL_TEMPLATE + jobId);
		},

		copy: function(params) {
			return CRUDSvc.post(TG_JOB_API.COPY_QUOTE, params);
		},
		delete: function(params) {
			return CRUDSvc.post(TG_JOB_API.DELETE_QUOTE, params);
		},
		showCancelJobModal: function(job) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/trugreen/job/templates/modals/TGCancelJobModal.html',
				controller: 'TGCancelJobModalCtrl',
				controllerAs: 'CancelJob',
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					job: function () {
						return angular.copy(job);
					}
				}
			});

			return modalInstance.result;
		},
		cancelJob: function(params) {
			return CRUDSvc.post(TG_JOB_API.CANCEL_JOB, params);
		},
		uncancelJob: function(params) {
			return CRUDSvc.post(TG_JOB_API.UNCANCEL_JOB, params);
		},
		markAsConfirmed: function(params) {
			return CRUDSvc.post(TG_JOB_API.MARK_AS_CONFIRMED, params);
		},
		preferredAppointmentTimes: function() {
			var deferred = $q.defer();

			// spoof response
			var response = {
				data: {
					success: true,
					message: '',
					options: [
						{
							preferred_treatment_time: 'Anytime Treatment',
							label: 'Anytime Treatment'
						},
						{
							preferred_treatment_time: 'AM',
							label: 'AM'
						},
						{
							preferred_treatment_time: 'PM',
							label: 'PM'
						},
						{
							preferred_treatment_time: 'Specific',
							label: 'Specific'
						}
					]
				}
			};

			deferred.resolve(response);

			return deferred.promise;
		},
		export: function(params) {
			var newParams = angular.extend({}, params, {
				'format': 'csv'
			});
			var query = $.param(newParams);
			window.open(TG_JOB_API.INDEX + '?' + query);
		},
		quotesByCustomerOrCustomerEnquiry: function (customerId, params, includeDeleted) {
			var newParams = angular.extend({}, params, {
				filter: {
					converted: false,
					customerOrCustomerEnquiry: customerId,
					includeDeleted: includeDeleted,
				}
			});
			return CRUDSvc.get(TG_JOB_API.INDEX, newParams);
		},
		jobsByCustomer: function (customerId, params) {
			var newParams = angular.extend({}, params, {
				filter: {
					converted: true,
					customer: customerId
				}
			});
			return CRUDSvc.get(TG_JOB_API.INDEX, newParams);
		},
		customerInvoiceOptions: function (customerId) {
			return CRUDSvc.get('api/trugreen/job/customer-invoice-options/' + customerId);
		},
		// updates lawn sizes, treatment prices, product costs as relevant
		updateJobTreatments: function (newJob, oldJob) {
			var deferred = $q.defer();
			var promises = [];

			angular.forEach(newJob.treatments, function (jobTreatment) {
				promises.push(self.updateJobTreatment(newJob, jobTreatment, oldJob));
			});

			$q.all(promises)
				.then(function () {
					deferred.resolve(true);
				});

			return deferred.promise;
		},
		updateJobTreatment: function (newJob, jobTreatment, oldJob) {
			var deferred = $q.defer();
			var customerId = angular.isObject(newJob.customer) ? newJob.customer.id : null;

			// ignore custom price treatments and those marked for deletion
			if (jobTreatment.is_custom_price !== true && jobTreatment.delete !== true) {
				// TODO: only update the lawn segments that match the parent job
				// update lawn sizes
				if (jobTreatment.lawn_all === true ) {
					jobTreatment.lawn_size_m2 = parseInt(newJob.lawn_front_size) + parseInt(newJob.lawn_rear_size) + parseInt(newJob.lawn_side_size) + parseInt(newJob.lawn_other_size);
				}
				else {
					// should probably update custom portions if smaller than new size, but BMS1 doesn't so leave for now - SR
					// if the current job treatment lawn portion equals the old job lawn portion then update to match, else leave alone
					jobTreatment.lawn_front_size = jobTreatment.lawn_front === true && parseInt(jobTreatment.lawn_front_size) === parseInt(oldJob.lawn_front_size) ? parseInt(newJob.lawn_front_size) : jobTreatment.lawn_front_size;
					jobTreatment.lawn_rear_size = jobTreatment.lawn_rear === true && parseInt(jobTreatment.lawn_rear_size) === parseInt(oldJob.lawn_rear_size) ? parseInt(newJob.lawn_rear_size) : jobTreatment.lawn_rear_size;
					jobTreatment.lawn_side_size = jobTreatment.lawn_side === true && parseInt(jobTreatment.lawn_side_size) === parseInt(oldJob.lawn_side_size) ? parseInt(newJob.lawn_side_size) : jobTreatment.lawn_side_size;
					jobTreatment.lawn_other_size = jobTreatment.lawn_other === true && parseInt(jobTreatment.lawn_other_size) === parseInt(oldJob.lawn_other_size) ? parseInt(newJob.lawn_other_size) : jobTreatment.lawn_other_size;
					angular.extend(jobTreatment, {
						lawn_size_m2: jobTreatment.lawn_front_size + jobTreatment.lawn_rear_size + jobTreatment.lawn_side_size + jobTreatment.lawn_other_size
					});
				}
				// fetch new prices
				TGTreatmentSvc.getTreatmentPrice(jobTreatment.treatment_attr.id, jobTreatment.lawn_size_m2, customerId)
					.then(function (response) {
						// TODO: Set the customer price and is_custom_price attribute if available
						var tmp_treatment_price;
						tmp_treatment_price = response.data.treatment_price;
						// only set treatment price if not custom
						if (jobTreatment.is_custom_price !== true) {
							angular.extend(jobTreatment, {
								selling_price_per_treatment_net: tmp_treatment_price.treatment_rrp_net,
								annual_treatment_price_net: tmp_treatment_price.treatment_rrp_net * jobTreatment.treatments_per_year,
								selling_price_per_treatment_gross: tmp_treatment_price.treatment_rrp_gross,
								annual_treatment_price_gross: tmp_treatment_price.treatment_rrp_gross * jobTreatment.treatments_per_year
							});
						}
						deferred.resolve(true);
					});

				// always update product costs

				angular.forEach(jobTreatment.products, function (treatmentProduct) {
					var productCost, productCostPercent;
					if (angular.isObject(treatmentProduct.product_attr)) {
						productCost = parseFloat(treatmentProduct.product_attr.cost_per_m2) * parseInt(jobTreatment.lawn_size_m2) * parseInt(jobTreatment.treatments_per_year);
						if (jobTreatment.annual_treatment_price_net >= 0.01) {
							// this should probably be based on gross, sticking with how BMS1 works for now
							productCostPercent = productCost / jobTreatment.annual_treatment_price_net * 100;
							// round 2 dp
							productCostPercent = Math.round(productCostPercent * 100) / 100;
						}
						else {
							productCostPercent = 100;
						}
					}
					else {
						productCost = null;
						productCostPercent = null;
					}
					angular.extend(treatmentProduct, {
						product_cost: productCost,
						product_cost_percent: productCostPercent
					});
				});
			}

			return deferred.promise;
		}
	};
	return self;

}).constant('TG_JOB_API', {
	INDEX: 'api/trugreen/job/index',
	QUOTE_INDEX: 'api/trugreen/quote/index',
	MARK_AS_CONFIRMED: 'api/trugreen/quote/mark-as-confirmed',
	SAVE: 'api/trugreen/job/save',
	CANCEL_JOB: 'api/trugreen/job/cancel-job',
	UNCANCEL_JOB: 'api/trugreen/job/uncancel-job',
	READ: 'api/trugreen/job/read/',
	COPY_QUOTE: 'api/trugreen/job/copy',
	DELETE_QUOTE: 'api/trugreen/job/delete',
	CONVERT_TO_QUOTE: 'api/trugreen/job/convert-to-quote',
	TP_EMAIL_TEMPLATE: 'api/trugreen/job/get-treatment-plan-email-template/',
});
